import dayjs from "dayjs";
import config from '@config/config';

export const COMMON_ABORTION_CONSTANTS = {
  ABORTION_TYPE: 'abortion_type',
  METHOD_OF_ABORTION: 'method_of_abortion',
  POST_ABORTION: 'post_abortion_mtp_complications_identified',
  SUCCESS_MSG: 'Abortion Details has been successfully created',
  CLOSE_FORM: 'Do you want to close the form?',
  ABORTION_DETAILS: 'Abortion Details',
  ABORTION: 'abortion',

};

export const abortionData = {
  typeOfAbortion: {
    '#type': 'select',
    '#title': 'Type of Abortion',
    '#webform_key': 'typeOfAbortion',
    '#required': true,
  },
  dateOfAbortion: {
    '#type': 'date',
    '#title': 'Date of Abortion',
    '#webform_key': 'dateOfAbortion',
    '#required': false,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#isDisabled':true,
    '#useRelativePopup': true,
  },
  methodOfAbortion: {
    '#type': 'select',
    '#title': 'Method of Abortion',
    '#webform_key': 'methodOfAbortion',
    '#required': false,
    '#isDisabled':true
  },
  postAbortion: {
    '#type': 'select',
    '#title': 'Post of Abortion/MTP complication identified',
    '#webform_key': 'postAbortion',
    '#required': false,
    '#isDisabled':true
  },
  facilityType: {
      '#type': 'select',
      '#title': 'Facility Type',
      '#webform_key': 'facilityType',
      '#required': true,
      '#options': []
    },
    facilityName: {
      '#type': 'select',
      '#title': 'Facility Name',
      '#webform_key': 'facilityName',
      '#required': true,
      '#options': []
    },
    hprName: {
      '#type': 'select',
      '#title': 'Health Provider Name',
      '#webform_key': 'hprName',
      '#required': true,
    },
    ashaName: {
      '#type': 'select',
      '#title': 'Asha Name',
      '#webform_key': 'ashaName',
    },
     dateOfVisit: {
      '#type': 'date',
      '#title': 'Date of Visit',
      '#webform_key': 'dateOfVisit',
      '#required': true,
      "#minDate": dayjs().subtract(config.serviceDateLimit, 'day'),
      '#maxDate': new Date(),
      '#useRelativePopup': true,
    },

}

export const abortionObj: any = {
  dateOfAbortion: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  typeOfAbortion: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
    reportId: '',
    serviceId: '',
  },
  methodOfAbortion: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
    reportId: '',
    serviceId: '',
  },
  postAbortion: {
    isError: false,
    message: '',
    isDisable: false,
    value: false,
    reportId: '',
    serviceId: '',
  },
  facilityType: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: ''
  },
  facilityName: {
    isError: false,
    message: '',
    id: '',
    isDisable: false,
    value: '',
  },
  hprName: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  ashaName: {
    isError: false,
    message: '',
    id: '',
    isDisable: false,
    value: '',
  },
  dateOfVisit: {
    isError: false,
    message: '',
    id: '',
    isDisable: false,
    value: '',
  }
};

export const ABORTION_ERROR_MESSAGES = {
  FIELD_REQUIRED: (fieldName: any) => `${fieldName} cannot be blank.`,
  GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
  POST_API_ERROR_MESSAGE: (apiName: string) => `Error in creating ${apiName}.`,
  UNSAVED_CHANGES: 'You have unsaved changes. Are you sure you want to leave without saving?',
  ABORTION_NOT_ALLOWED: 'Pregnancy registration is allowed 35 days after Abortion.',
};

export const ABORTION_API_DETAILS = {
  CREATE_ABORTION: 'abortion',
  ABORTION_DETAILS: 'abortion details',
  SERVICE_REPORT: 'service report',
};

export const ABORTION_FIELDS_NAME = {
  DATE_OF_ABORTION: 'Date of Abortion',
  TYPE_OF_ABORTION: 'Type of Abortion',
  METHOD_OF_ABORTION: 'Method of Abortion',
  POST_OF_ABORTION: 'Post of Abortion/MTP complication identified',
};

export const NAVIGATION_ABORTION = {
  ABORTION_FORM: '/beneficiaries/abortion/abortion-form',
}


export const ABORTION_VIEW_OBJ:any = {
  date_of_abortion: {
    'title': 'Date of Abortion',
    'webform_key': 'date_of_abortion',
    'value': ''
  },
  v_abortion_type_name: {
    'title': 'Type of Abortion',
    'webform_key': 'v_abortion_type_name',
    'value': ''
  },
  v_method_of_abortion_name: {
    'title': 'Method of Abortion',
    'webform_key': 'v_method_of_abortion_name',
    'value': ''
  },
  v_post_abortion_mtp_complications_identified_name: {
    'title': 'Post of Abortion/MTP complication identified',
    'webform_key': 'v_post_abortion_mtp_complications_identified_name',
    'value': ''
  },
};
